<template lang="pug">
    div.card
        header.card-header
            p.card-header-title
                span.icon
                    i.fas.fa-code
                span Example Vue Component
        div.card-content
            div.content I'm an example Vue component!
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        }
    }
</script>
